import React, { Component } from "react";
import { Subscribe } from "unstated";
import StateContainer from "../../state/StateContainer";

import "./Compass.css";
import deviceHelper from "../../utils/helpers/deviceHelper";

class Compass extends Component {
  state = {};

  /**
   * Sets the rotation angle depending on the rotation of the scene and starting angle set in umbraco.
   */
  setRotationAngle() {
    const angle =
      this.props.hotspotAngle * -57.2958 + this.props.compassStartingAngle;
    return Math.round(angle);
  }

  
  render() {
    const isMobile = deviceHelper.isMobileDevice();

    const containerPadding =
      this.props.unstated.state.orbViews.length > 0
        ? `${isMobile ? "20px" : "60px"} 60px 0 0`
        : `${isMobile ? "20px" : "60px"} 30px 0 0`;

    return (
      <div
        className="compass-container"
        style={{ padding: containerPadding }}
      >
      <div
        className="compass-frame"
        style={{
          backgroundImage: `Url(${this.props.unstated.state.compassFrame})`,
          transform: `rotate(${this.setRotationAngle()}deg)`
        }}
      >
        <div
          className="compass-pointer"
          style={{
            backgroundImage: `Url(${this.props.unstated.state.compassPointer})`,
          }}
        ></div>
      </div>
    </div>
    );
  }
}

const CompassWithUnstated = (props) => {
  return (
    <Subscribe to={[StateContainer]}>
      {unstated => <Compass {...props} unstated={unstated}/>}
    </Subscribe>
  )
}

export default CompassWithUnstated;
